import { EmployeeLocations } from './EmployeeLocations'
import { AdminLocations } from './AdminLocation'
import { arrayOfRoutes } from './Locations'
import { matchPath } from 'react-router-dom'
import LocalStorage from 'shared/LocalStorage'
import employeePlatformService from 'redux/employeePlatform/employeePlatformService'

/*
  This function is to get the platform type from the pathname

  If we know we are on the employer or employee path, we can set the platform type in local storage
  and return the platform type

  If we don't know we are on the employer or employee path like login etc.
  we can check the local storage for the platform type and return it

  If we don't know we are on the employer or employee path and the local storage is not set, we return null
*/
export const getPlatformType = () => {
  try {
    const employeeLocationsArray = arrayOfRoutes(EmployeeLocations)
    const adminLocationsArray = arrayOfRoutes(AdminLocations)
    const path = window.location.pathname

    // Matching the employer paths with the path
    let isEmployerPath = false
    let isEmployeePath = false

    adminLocationsArray.forEach((locationObject) => {
      const { path: locationPath } = locationObject
      if (matchPath(path, locationPath)) {
        isEmployerPath = true
      }
    })

    if (isEmployerPath) {
      setFleetPlatformType('employer')
      return 'employer'
    }

    employeeLocationsArray.forEach((locationObject) => {
      const { path: locationPath } = locationObject
      if (matchPath(path, locationPath)) {
        isEmployeePath = true
      }
    })

    if (isEmployeePath) {
      setFleetPlatformType('employee')
      return 'employee'
    }

    const platformType = LocalStorage.getItem('platformType')
    if (platformType) {
      return platformType
    }

    return null
  } catch (error) {
    return null
  }
}

export const setFleetPlatformType = (platformType: string) => {
  LocalStorage.setItem('platformType', platformType)
}

/*
  Initialize stripe with connected account if
  - for the employee platform
  - the employer has a connected account
  - otherwise, initialize stripe with the root account
*/
export const getStripeMode = async (platformType: string) => {
  try {
    // Employer doesn't need a connected account
    if (platformType === 'employer') {
      return {
        mode: 'root',
        connectedAccount: null,
      }
    }

    // Otherwise we need to get the profile data
    const profileResponse = await employeePlatformService.getProfileData()

    const profileData = profileResponse.data

    // If employee profile data is not loaded yet, don't do anything
    if (!profileData) {
      return {
        mode: 'root',
        connectedAccount: null,
      }
    }

    // If employee profile data is loaded and has a connected account, use it
    if (platformType === 'employee' && profileData.connectedAccount) {
      return {
        mode: 'connected',
        connectedAccount: profileData.connectedAccount,
      }
    } else {
      return {
        mode: 'root',
        connectedAccount: null,
      }
    }
  } catch (error) {
    return {
      mode: 'root',
      connectedAccount: null,
    }
  }
}
